module.exports = __webpack_public_path__ + "static/img/警示.816af07.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dialog/警示.png
// module id = 117
// module chunks = 133 176 379 380